// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DefaultHeaderActions__container-a2be8f {
  display: flex;
  flex-direction: row;
}

.DefaultHeaderActions__icon-container-c0028e,
.DefaultHeaderActions__action-button-a67942,
.DefaultHeaderActions__startStreaming-cc5553 {
  margin-inline-start: 16px;
}

.DefaultHeaderActions__startStreaming-cc5553 circle {
  fill: var(--addition-160);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatHeader/DefaultHeader/DefaultHeaderActions/DefaultHeaderActions.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;;;EAGE,yBAAA;AACF;;AAEA;EACE,yBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n}\n\n.icon-container,\n.action-button,\n.startStreaming {\n  margin-inline-start: 16px;\n}\n\n.startStreaming circle {\n  fill: var(--addition-160);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DefaultHeaderActions__container-a2be8f`,
	"icon-container": `DefaultHeaderActions__icon-container-c0028e`,
	"iconContainer": `DefaultHeaderActions__icon-container-c0028e`,
	"action-button": `DefaultHeaderActions__action-button-a67942`,
	"actionButton": `DefaultHeaderActions__action-button-a67942`,
	"startStreaming": `DefaultHeaderActions__startStreaming-cc5553`
};
module.exports = ___CSS_LOADER_EXPORT___;
